import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PODetails from '../PODetails';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { CloseIcon } from '../../../../bombiix-icon';

function POPreviewModal({ onOpen, toggle, data, loading }) {
  const { t } = useTranslation('common');

  const callPoDetails = () => {
    return data ? <PODetails fromForm={false} /> : <div className=" text-center">{t('EDIT_FIELD_MODAL.NO_PREVIEW')}</div>;
  };
  return (
    <Modal className="relative-width-modal custom-modal modal-medium " size="lg" show={onOpen} onHide={toggle} backdrop="static" centered>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">{t('EDIT_FIELD_MODAL.PO_PREVIEW')}</Modal.Title>
          <CloseIcon size={28} onClick={toggle} className="cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body className="px-md-5">{loading ? <Loader /> : callPoDetails()}</Modal.Body>
    </Modal>
  );
}

export default POPreviewModal;
